<template>
    <Popup ref="popup" :animation="'scale'">
        <div>
            <div class="redeem-container">
                <img class="redeem-img" :src="getCongratulationImage()" @click="hide">
                <!--img class="close-btn" :src="_global.assetsRoot + '/airdrop_collect_btn_close.png'" @click="hide"-->
            </div>
        </div>
    </Popup>
</template>

<script>
import Popup from '../Popup.vue';
export default {
    props: {
        userID: String
    },
    data() {
        return {
        }
    },
    methods: {
        show() { this.$refs.popup.show() },
        hide() { this.$refs.popup.hide() },
        getCongratulationImage() {
            let userLanguage = this._global.user.lang;

            switch(userLanguage){
                case 'pt':
                    return this._global.assetsRoot + '/congratulations_pt.png';
                    break;
                case 'es':
                    return this._global.assetsRoot + '/congratulations_es.png';
                    break;
                default:
                    return this._global.assetsRoot + '/congratulations_en.png';
                    break
            }
        },
    },
    components: { Popup }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/variables.scss";

.redeem-container {
    display: inline-block;
    position: relative;

    .redeem-img {
        width: 100%;
        height: auto; 
    }

    .close-btn {
        width: 60px;
        height: 60px;
        position: absolute;
        top: 28px;
        right: -14px;
        cursor: pointer;
        z-index: 2;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/Redeem.vue